import React from 'react';
import Hero from '../common/Hero';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import { useBusinessData } from '../../context/BusinessContext';
import '../../css/Home.css';

// Get reference to specific icons we use directly in the code
const { faChartLine } = solidIcons;

// Icon mapping function to get the right FontAwesome icon from the string in JSON
const iconMapping = (iconName) => {
  return iconName && solidIcons[iconName] ? solidIcons[iconName] : solidIcons.faChartLine;
};

const Home = () => {
  const { loading, error, getData, hasData, getImageUrl } = useBusinessData();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error loading data: {error}</div>;
  }

  const features = getData('features', []);
  const statistics = getData('statistics', []);
  
  // Get CTA background image from JSON using getImageUrl
  const ctaImage = getImageUrl('images.backgrounds.cta', 'cta-bg.jpg');
  
  // Create inline style for CTA background image - using URL directly
  const ctaStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url('${ctaImage}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed'
  };

  return (
    <>
      <Hero />
      
      {/* Features Section */}
      {hasData('features') && features.length > 0 && (
        <section className="section">
          <div className="container">
            <h2 className="section-title">{getData('ui.home.featuresSection.title', 'Why Choose Us')}</h2>
            <p className="section-subtitle">{getData('ui.home.featuresSection.subtitle', 'We provide innovative solutions to help your business grow and succeed in today\'s competitive market.')}</p>
            
            <div className="features-grid">
              {features.map((feature, index) => (
                <div className="feature-card" key={index}>
                  <FontAwesomeIcon 
                    icon={iconMapping(feature.icon) || faChartLine} 
                    className="feature-icon" 
                  />
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      
      {/* Stats Section */}
      {hasData('statistics') && statistics.length > 0 && (
        <section className="section section-dark">
          <div className="container">
            <div className="stats-container">
              {statistics.map((stat, index) => (
                <div className="stat-item" key={index}>
                  <h3>{stat.value}</h3>
                  <p>{stat.title}</p>
                  {stat.icon && (
                    <FontAwesomeIcon 
                      icon={iconMapping(stat.icon)}
                      className="stat-icon" 
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      
      {/* CTA Section */}
      <section className="section cta-section" style={ctaStyle}>
        <div className="container">
          <div className="cta-content">
            <h2>{getData('ui.home.cta.title', 'Ready to grow your business?')}</h2>
            <p>{getData('ui.home.cta.subtitle', 'Schedule a free consultation with our experts today.')}</p>
            <a href="/contact" className="btn btn-primary">{getData('ui.global.ctaButton', 'Get Started')}</a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home; 